module.exports = __webpack_public_path__ + "static/media/button-off.f76b61b2.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/button-off.gif
// module id = 290
// module chunks = 0